
<div class="agpr-middlePanel-leftPanel">
    <div class="agpr-middlePanel">
        <agpr-scroll-panel #scrollPanel>
            <div
                *ngIf="!isLoader"
                class="agpr-previewPanel"
                [formGroup]="storyFormGroup"
            >
                <div>
                    <input
                        class="agpr-previewPanel-storyName"
                        #storyNameInput
                        type = "text"
                        formControlName="name"
                        [maxlength] = "256"
                        pInputText
                        [placeholder] = "'Name Your Story'"
                        [attr.disabled] = "isRetracted ? '' : null"
                        aria-label="Story Name"
                        aria-describedby="story_name_error"
                    />
                    <agpr-form-message
                        *ngIf="(isSubmitted || isPublished) && name.value.trim() == ''"
                        id="story_name_error"
                    >
                        {{ storyLocalization.storyNameErrorMessage }}
                    </agpr-form-message>
                    <input
                        *ngIf="id > 0"
                        type="hidden"
                        [(ngModel)]="id"
                        [ngModelOptions]="{standalone: true}"
                    />
                </div>
                <div class="agpr-previewPanel-storyMainBlock">
                    <div
                        *ngIf="statusId == statusEnum.PUBLISHED"
                        class="agpr-previewPanel-ribbonHead"
                    >
                        {{publishedLabel}}
                    </div>
                    <div class="agpr-previewPanel-storyMainBlock-components">
                        <div
                            #companyLogo
                            class="agpr-previewPanel-storyMainBlock-components-box"
                        >
                            <agpr-browse-image
                                *ngIf="showLogoButton"
                                (getImageUrl)="getBrowsedLogo($event)"
                                (getImageError) = "showImageError($event)"
                                (doDelete)="getIconsDeleteStatus($event)"
                                [showPlaceholder]="showLogoPlaceholder"
                                [imageUrl]="logoUrl"
                                [imageId] = "logoId"
                                imageClass = "agpr-browseImage-companyLogo"
                                [showImageHtml]="showCompanyImageHtml"
                                [showImageInput]="showCompanyImageInput"
                                [placeholderName] = "logoPlaceholderName"
                                [imageIcon] = "logoIcon"
                                [showDeleteButton]="true"
                                [(isImageDirty)] = "isLogoDirty"
                                borderClass="agpr-browseImage-outerBlock agpr-browseImage-companyLogo"
                                ariaLabel="Company Logo"
                            >
                            </agpr-browse-image>
                        </div>
                        <div class="agpr-previewPanel-storyMainBlock-components-box">
                            <agpr-autosize-text-area
                                formControlName="headline"
                                [placeholder]="'Headline'"
                                [placeholderIcon]="'agpr-i-headline'"
                                [textAreaMaxLength] = "256"
                                [textAreaCols] = "100"
                                [isDisabled] = "isRetracted"
                                [boxStyle]="{'font-size':'28px','font-weight':'bold','min-height': '45px', 'line-height':'normal'}"
                                errorsId="headline_error"
                                ariaLabel="Headline"
                            >
                            </agpr-autosize-text-area>
                            <agpr-form-message
                                *ngIf="isPublished && headline.value.trim()== ''"
                                id="headline_error"
                            >
                                {{ storyLocalization.storyHeadlineErrorMessage }}
                            </agpr-form-message>
                        </div>
                        <div class="agpr-previewPanel-storyMainBlock-components-box agpr-previewPanel-companyDateBlock">
                            <div>
                                <agpr-autosize-text-area
                                    *ngIf="showCompanyPlaceholder"
                                    formControlName="companyName"
                                    [placeholder]="'Company Name'"
                                    [placeholderIcon]="'fa-kit-duotone fa-agpr-outlet'"
                                    [isMultiLine] = "false"
                                    [textAreaMaxLength] = "64"
                                    [isDisabled] = "isRetracted"
                                    [boxStyle]="{'line-height': 'normal', 'padding':'0.5em'}"
                                    errorsId="company_name_error"
                                    ariaLabel="Company Name"
                                >
                                </agpr-autosize-text-area>
                                <agpr-form-message
                                    *ngIf="isPublished && companyName.value.trim()== ''"
                                    id="company_name_error"
                                >
                                    {{ storyLocalization.storyCompanyNameErrorMessage }}
                                </agpr-form-message>
                                <input
                                    *ngIf="companyId != null && companyId > 0"
                                    type="hidden"
                                    [(ngModel)]="companyId"
                                    [ngModelOptions]="{standalone: true}"
                                />
                            </div>
                            <div>
                                <div
                                    *ngIf="id > 0 && statusId == statusEnum.PUBLISHED && storyResponseModel.publishedDate > 0"
                                    class="agpr-previewPanel-dateTime"
                                >
                                    {{dateText}} {{ storyModifiedDate }}
                                </div>
                                <div
                                    *ngIf="id > 0 && statusId == statusEnum.SCHEDULED && storyResponseModel.publishedDate > 0"
                                    class="agpr-previewPanel-dateTime"
                                >
                                    Scheduled Date {{ getFormattedTime(publishDate, publishTime.timeZone) }}
                                </div>
                            </div>
                        </div>
                        <div class="agpr-previewPanel-storyMainBlock-components-box agpr-previewPanel-dateline">
                            <div class="agpr-previewPanel-datelineItem">
                                <agpr-autosize-text-area
                                    formControlName="datelineLocation"
                                    [placeholder]="'Dateline Location'"
                                    [maxlength]="64"
                                    [placeholderIcon]="'fa-regular fa-duotone fa-location-dot'"
                                    [isMultiLine]="false"
                                    [textAreaMaxLength]="64"
                                    [isDisabled]="isRetracted"
                                    [boxStyle]="{'font-weight':'bold'}"
                                    errorsId="location_error"
                                    ariaLabel="Location"
                                >
                                </agpr-autosize-text-area>
                                <agpr-form-message
                                    *ngIf="isPublished && !datelineLocation.value"
                                    id="location_error"
                                >
                                    Dateline Location required.
                                </agpr-form-message>
                            </div>
                            <div class="agpr-previewPanel-datelineItem">
                                <agpr-news-date-picker
                                    [(ngModel)]="datelineDate"
                                    [placeholderIcon]="'fa-duotone fa-regular fa-calendar-range'"
                                    [placeholder]="'Dateline Date'"
                                    [isDisabled]="isRetracted"
                                    (ngModelChange)="onModelChanged()"
                                    [ngModelOptions]="{standalone: true}"
                                    errorsId="date_error"
                                    [calendarDateFormat]="dateFormat"
                                    [previewDateFormat]="dateFormat"
                                >
                                </agpr-news-date-picker>
                                <agpr-form-message
                                    *ngIf="isPublished && !datelineDate"
                                    id="date_error"
                                >
                                    Dateline Date required.
                                </agpr-form-message>
                            </div>
                        </div>
                        <div class="agpr-previewPanel-storyMainBlock-components-box">
                            <agpr-content-editable-box
                                id="body_block"
                                formControlName="body"
                                [placeholderIcon]="'fa-solid fa-align-left'"
                                [placeholder]="'Body'"
                                [boxStyle]="{'min-height':'200px'}"
                                [isRetracted] = "isRetracted"
                                [maxLength] = "12000"
                                [maxHtmlContentLength] ="bodyFormattedTextLimit"
                                [htmlContentLimitExceedMessage] = "storyLocalization.storyBodyTextLengthErrorMessage"
                                errorsId="body_error"
                                ariaLabel="Body"
                            >
                            </agpr-content-editable-box>
                            <agpr-form-message
                                *ngIf="isPublished && (!body || body.value.trim() == '')"
                                id="body_error"
                            >
                                {{storyLocalization.storyBodyTextErrorMessage}}
                            </agpr-form-message>
                        </div>
                        <div *ngIf="bodyContents.length > 0">
                            <div
                                #bodyComponent
                                *ngFor="let bodyContent of bodyContents; let i = index"
                                class="agpr-previewPanel-storyMainBlock-components-box"
                            >
                                <agpr-browse-image
                                    *ngIf="bodyContent.bodyContentType === BodyContentTypes.Image"
                                    (getImageUrl)="getBrowsedImage($event, bodyContent)"
                                    (getImageError)="showImageError($event)"
                                    (doDelete)="deleteBodyContent(bodyContent)"
                                    [showPlaceholder]="true"
                                    [imageId]="bodyContent.bodyContentId"
                                    [imageUrl]="bodyContent.bodyContent"
                                    [showImageHtml]="!!bodyContent.bodyContent"
                                    [showImageInput]="!bodyContent.bodyContent"
                                    [showDeleteButton]="true"
                                    [isDisabled]="isRetracted"
                                    [showMoveButtons]="true"
                                    [moveUpDisabled]="i <= 0"
                                    [moveDownDisabled]="i >= bodyContents.length - 1"
                                    (moveUp)="moveBodyContentUp(i)"
                                    (moveDown)="moveBodyContentDown(i)"
                                >
                                </agpr-browse-image>
                                <agpr-content-editable-box
                                    id="text_block_{{i}}"
                                    [(ngModel)]="bodyContent.bodyContent"
                                    [ngModelOptions]="{standalone: true}"
                                    *ngIf = "bodyContent.bodyContentType === BodyContentTypes.Text"
                                    [placeholder]="'Text'"
                                    [placeholderIcon]="'fa-solid fa-align-left'"
                                    [maxLength]="12000"
                                    (ngModelChange)="onModelChanged()"
                                    [isRetracted] = "isRetracted"
                                    [showDelete] = "true"
                                    (onDeleteClick)="deleteBodyContent(bodyContent)"
                                    [showMoveButtons]="true"
                                    [moveUpDisabled]="i <= 0"
                                    [moveDownDisabled]="i >= bodyContents.length - 1"
                                    (moveUp)="moveBodyContentUp(i)"
                                    (moveDown)="moveBodyContentDown(i)"
                                    [maxHtmlContentLength]="bodyFormattedTextLimit"
                                    htmlContentLimitExceedMessage = "Formatted character limit exceeded."
                                >
                                </agpr-content-editable-box>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="agpr-previewPanel-storyOptionalBlock">
                    <div
                        #about
                        *ngIf="aboutUsButtonDisabled"
                        class="agpr-previewPanel-storyOptionalBlockBox agpr-previewPanel-aboutUsBox"
                    >
                        <div
                            *ngIf="aboutUs"
                            class="agpr-previewPanel-placeholder"
                        >
                            ABOUT US
                        </div>
                        <agpr-content-editable-box
                            id="about_us_block"
                            *ngIf="aboutUsButtonDisabled"
                            formControlName="aboutUs"
                            (onDeleteClick)="onDelete();"
                            [showDelete]="true"
                            [placeholderIcon]="'fa-regular fa-duotone fa-screen-users'"
                            [placeholder]="'About Us'"
                            [boxStyle]="{'min-height':'100px', 'background':'#fff'}"
                            [isRetracted] = "isRetracted"
                            [maxLength] = "5000"
                            ariaLabel="About Us"
                        >
                        </agpr-content-editable-box>
                    </div>
                    <div
                        #contacts
                        class="agpr-previewPanel-storyOptionalBlockBox"
                    >
                        <div
                            *ngIf="((contactsDataSource.all() | async)?.length>0)"
                            class="agpr-previewPanel-placeholder"
                        >
                            CONTACTS
                        </div>
                        <agpr-contacts
                            [dataSource]="contactsDataSource"
                            [buttons]="contactButtons"
                            [maxContactItems]="3"
                            [minContactItems]="1"
                            [localization] = "localization"
                            [isDisabled] = "isRetracted"
                            [showImageNormalMode]="showImageNormalMode"
                            [(isContactDirty)] = "isContactDirty"
                            [mandatoryFields]="['name']"
                            [showPublishErrors]="isPublished && contactsPublishErrors"
                            [showDraftErrors]="isSubmitted && contactsDraftErrors"
                            (isContactDirtyChange)="checkForContactsError();checkForContactsEmailError()"
                            (controlDelete)= "onContactControlDelete();"
                            (getImageError) = "showImageError($event)"
                            errorsId="contacts_errors"
                            [required]="false"
                            [showRequiredMessage]="true"
                        >
                        </agpr-contacts>
                        <ul id="contacts_errors">
                            <li *ngIf="(isPublished && contactsPublishErrors)">
                                <agpr-form-message>
                                    {{ storyLocalization.contactValidationMessage }}
                                </agpr-form-message>
                            </li>
                            <li *ngIf="(isSubmitted && contactsDraftErrors)">
                                <agpr-form-message>
                                    {{ storyLocalization.contactsEmailError }}
                                </agpr-form-message>
                            </li>
                        </ul>
                    </div>
                    <div
                        #links
                        *ngIf="linkButtonDisabled"
                        class="agpr-previewPanel-storyOptionalBlockBox"
                    >
                        <div
                            *ngIf="(linksDataSource.all() | async)?.length>0"
                            class="agpr-previewPanel-placeholder"
                        >
                            LINKS
                        </div>
                        <agpr-links
                            [dataSource]="linksDataSource"
                            [buttons]="linkButtons"
                            [maxLinkItems]="3"
                            [isDisabled] = "isRetracted"
                            [(isLinkDirty)] = "isLinkDirty"
                            (controlDelete)= "onLinkControlDelete();"
                            linkFormatErrorMessage="Invalid link format.">
                        </agpr-links>
                    </div>
                </div>
            </div>
        </agpr-scroll-panel>
        <div
            *ngIf="!isLoader && !isRetracted"
            class="agpr-previewPanel-actionBar"
        >
            <agpr-footer-action-bar
               [rightButtonGroup]="rightGroupButton(id, statusId, storyResponseModel.publishedDate)">
            </agpr-footer-action-bar>
        </div>
    </div>
</div>

<div
    *ngIf="isLoader"
    class="agpr-previewPanel-overlay"
>
    <div
        [agprLoading]="true"
        class="loader"
    ></div>
</div>

